module.exports = __webpack_public_path__ + "static/img/r21.b12d0d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/r21.jpg
// module id = K+cI
// module chunks = 73